import HttpHelper from './helper';


export const playerSearchEndpoints = {
    getPlayer: (params) => HttpHelper.baseAxios
        .get('/full-search', { params })
        .then((res) => res?.data)
        .catch((err) => err?.response?.data),
};
